import './styles.scss'
import * as React from 'react'

import Basic from './Basic'
import Advanced from './Advanced'
import OutOfOffice from './OutOfOffice'

const stylesScheduleMode = {
  advanced : 'schedules--advanced',
  office : 'schedules--out-office',
  nauta : 'schedules--out-office',
  chatweb : 'schedules--out-office',
  refundAutomatic : 'schedules--out-office',
  nightTime : 'schedules--out-office'
}

const Index = (props) => {
  const [scheduleMode, setScheduleMode] = React.useState(props.scheduleMode)

  const toggleMode = () => {
    if (scheduleMode === 'basic') {
      setScheduleMode('advanced')
    } else {
      setScheduleMode('basic')
    }
  }

  const getMode = () => {
    switch (scheduleMode) {
      case 'basic':
        return (
          <Basic
            closeModal={props.closeModal}
            schedules={props.schedules}
            saveSchedules={props.saveSchedules}
            toggleMode={toggleMode}
          />
        )
      case 'advanced':
        return (
          <Advanced
            closeModal={props.closeModal}
            schedules={props.schedules}
            saveSchedules={props.saveSchedules}
            toggleMode={toggleMode}
          />
        )
      case 'nightTime':
      case 'refundAutomatic':
      case 'office':
      case 'nauta':
      case 'chatweb':
        return (
          <OutOfOffice
            closeModal={props.closeModal}
            schedules={props.schedules}
            saveSchedules={props.saveSchedules}
            toggleMode={toggleMode}
            scheduleMode={scheduleMode}
            enableHolidays={props.outOfOfficeEnableHolidays}
            everyDay={props.outOfOfficeEnableEveryDay}
          />
        )
      default:
        return null
    }
  }

  return (
    <div
      className={
        `${stylesScheduleMode[scheduleMode]} schedules`
      }
    >
      {getMode()}
    </div>
  )
}

export default Index
